export function isVerySmallScreen(){ //i.e. mobile
    return window.innerWidth <= 600
}

export function isTallRatio(): boolean {
    return (window.innerHeight / window.innerWidth) > 1
}

export function isSmallScreen(): boolean {
    return window.innerHeight < 1000
}